export default __webpack_public_path__ + "static/media/Rectangle1.8ee899ee.png";